import React,{useEffect,useState} from "react";
import {Button,notification,Result,message,Col,Row,Modal, Form, Input} from "antd";
import {useHistory} from "react-router-dom";
import axios from 'util/Api'
import config from "../util/ApiforContext"
import ReCAPTCHA from "react-google-recaptcha";
import Screen from '../util/Extensions/Screens'
const FormItem = Form.Item;

const ResetPassword = (props) => {
const history = useHistory();
const recaptchaRef = React.createRef();
var errorList = [];
const captchaError = type => {
  notification[type]({
    message: 'Hata',
    description:
      'Girilen kod hatalı, tekrar deneyiniz.',
      duration: 5,
  });
};

  const errorListNotification = type => {
    errorList.map((item)=> {
      notification[type]({
        message: 'Hata',
        description:
        item
         ,
          duration: 4,
      });
    })
    errorList = []
  };
  const [isHavePsrGuid, setIsHavePsrGuid] = useState(true);
  const [smsValue, setSmsValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [captchaCode, setCaptchaCode] = useState("");
  const [smsPassword, setSmsPassword] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [visible, setVisible] = useState(false);
  const {initialMinute = 0} = props;
  const [ minutes, setMinutes ] = useState(initialMinute);
  const [seconds, setSeconds ] =  useState(180);
  const [errorText, setErrorText ] =  useState("");
  const [captchaKey, setCaptchaKey] = useState(0);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [recaptchaToken, setRecaptchaToken ] =  useState("");

  const setCode = captchaCode => {
    setCaptchaCode(captchaCode)
  }
  const showModal = () => {
    setSeconds(180)
    setErrorText("")
    setVisible(true)
  }
  function onSubmits() {
    const recaptchaValue = recaptchaRef.current.getValue();
    props.onSubmit(recaptchaValue);
  }
  const handleSubmit = (values) => {
    if(values.Sms === undefined || values.Sms === ""){
      setErrorText("*Lütfen giriş yapınız.")
      setLoadingBtn(false)
      setCaptchaKey(captchaKey + 1)
    }else{
      axios.post(`${config.apiUrl}/Auth/PsrRegex`,{
          SecurityKey: values.Sms,
          PsrGuid:props.match.params.psrGuid,
          PsrForRegex:userPassword
      },config.headers)
      .then(res => {
        if(res.data){
            openNotificationWithIcon('success');
            const hide = message.loading('İşleminiz gerçekleştiriliyor..', 0);
            setTimeout(hide, 2000);
            setTimeout(function () {
            history.push('/home')
           }.bind(this), 2000)
      }
      }).catch(
        error => {
          if(error.response.status === 406){
            error.response.data.data.map((item)=>{
              errorList.push(item);
            })
            errorListNotification('error')
            setLoading(false)
            setLoadingBtn(false)
            handleCancel()
            setCaptchaKey(captchaKey + 1)
            window.grecaptcha.reset();
            setRecaptchaToken("");
          }else{
            openNotificationWithIconWarning('error')}
            setLoading(false)
            setLoadingBtn(false)
            setCaptchaKey(captchaKey + 1)
            window.grecaptcha.reset();
            setRecaptchaToken("");
          }
    );
    setSmsValue(values.Sms)
  }
  }
  function onChange(value) {
    setRecaptchaToken(value);
  }
  useEffect(()=>{
    
    let myInterval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
            if (seconds === 0) {
                if (minutes === 0) {
                  handleCancel()
                } else {
                    setMinutes(minutes - 1);
                    setSeconds(59);
                }
            } 
        }, 1000)
        return ()=> {
            clearInterval(myInterval);
          };
    });
  const [form] = Form.useForm();

    const handleCancel = () => {
      setVisible(false)
      if(handleCancel){
        setLoading(false)
      }
      setLoadingBtn(false)
    };
  useEffect(() => {
    if(props.match.params.isPsrExpired === "true"){
      PsrChange90Days("error");
    }
    axios.get(`${config.apiUrl}/auth/IsHavePsrGuid?PsrGuid=${props.match.params.psrGuid}`,
     {})
     .then(res => {
        if(res.data){
          setIsHavePsrGuid(true)
        }
         }).catch(
          error => {
            if(error.response.status === 406){
              error.response.data.data.map((item)=>{
                errorList.push(item);
              })
              errorListNotification('error')
              setLoading(false)
              setLoadingBtn(false)
              handleCancel()
              history.push("/signin")
            }else{
              openNotificationWithIconWarning('error')}
              setLoading(false)
              setLoadingBtn(false)
              setCaptchaKey(captchaKey + 1)
             }
      );
  }, [])
  const onFinishFailed = errorInfo => {
  };
  const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
}
// let hide = () => {};
  const onFinish = values => {
   
    if(values.password !== values.confirm){
        NotSamePasswordWarning('error')
        setLoading(false)
        setCaptchaKey(captchaKey + 1)
    }else{
        axios.post(`${config.apiUrl}/Auth/PsrRegex`,{
          PsrGuid:props.match.params.psrGuid,
          PsrForRegex :values.password,
          RecaptchaToken: recaptchaToken
        },config.headers)
        .then(res => {
          if(res.data === true){
              setUserPassword(values.password)
              showModal()
        }
        }).catch(
          error => {
            if(error.response.status === 406){
              error.response.data.data.map((item)=>{
                errorList.push(item);
              })
              errorListNotification('error')
              setLoading(false)
              setLoadingBtn(false)
              handleCancel()
              setCaptchaKey(captchaKey + 1)
              window.grecaptcha.reset();
              setRecaptchaToken("");
            }else{
              openNotificationWithIconWarning('error')}
              setLoading(false)
              setLoadingBtn(false)
              setCaptchaKey(captchaKey + 1)
              window.grecaptcha.reset();
              setRecaptchaToken("");
            }
      );
    }
  };

  const openNotificationWithIcon = type => {
    notification[type]({
      message: 'BAŞARILI',
      description:
        'Şifre güncelleme işlemi başarı ile gerçekleşti.',
        duration: 2,
    });
  };
  const NotSamePasswordWarning = type => {
    notification[type]({
      message: 'HATA',
      description:
        'Şifreler aynı değil.',
        duration: 2,
    });
  };
  const PsrChange90Days = type => {
    notification[type]({
      message: 'HATA',
      description:
        'Şifrenizi 90 gün süre ile değiştirmeniz gerekmektedir.',
        duration: 6,
    });
  };
  const openNotificationWithIconWarning = type => {
    notification[type]({
      message: 'HATA',
      description:
        'Şifre güncelleme işlemi sırasında bir hata oluştu.',
        duration: 2,
    });
  };
  return (
    isHavePsrGuid === true ?
    <div className="gx-login-container"  style={{backgroundColor:'#f0f8ff'}}>
      <div className="gx-login-content">

        <div className="gx-login-header">
          {
            Screen.screen === 0 ? <img src={require("assets/images/AkodeRed.png")} alt="paratic" title="paratic" style={{width:'40%'}}/>
            :
            <img src={require("assets/images/AkodeRed.png")} alt="paratic" title="imzaPos" style={{width:'40%'}}/>
          }
          
        </div>
        <div className="gx-mb-4">
          <h3>Şifreyi Yenile</h3>
          <p>Hesabınızın yeni şifresini giriniz.</p>
        </div>

        <Form
          initialValues={{ remember: true }}
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className="gx-signin-form gx-form-row0">

          <FormItem rules={ [{required: true, message: 'Lütfen şifrenizi giriniz.'}]} name="password">
            <Input 
            autoComplete="off"
            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}  
            className='gx-input-lineheight' onKeyDown={ (evt) => evt.keyCode === 32 && evt.preventDefault() } type="password" placeholder="Yeni Şifrenizi Giriniz"/>
          </FormItem>

          <FormItem rules={ [{required: true, message: 'Lütfen şifrenizi giriniz.'}]} name="confirm">
            <Input
            autoComplete="off"
            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
            className='gx-input-lineheight' onKeyDown={ (evt) => evt.keyCode === 32 && evt.preventDefault() } placeholder="Yeni Şifrenizi Tekrar Giriniz" type="password"/>
          </FormItem>
         
          <form onSubmit={onSubmits} >
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey="6LfX1CIdAAAAAC9TS6J53DDfVYb4Xnn7gWJSWCdd"
            type={"image"}
            hl={"tr"}
            style={{marginLeft:20,marginBottom:20}}
            onChange={onChange}
          />
          </form>

          <FormItem>
            <Button type="primary" htmlType="submit"  onClick={() => setLoading(true)} loading={loading}>
              Yenile
            </Button>
          </FormItem>
        </Form>
     
        <Modal 
      visible={visible} onOk={form.submit} okButtonProps={{hidden:true}} cancelButtonProps={{hidden:true}} footer={null} onCancel={handleCancel}>
      <p style={{marginTop:10,textAlign:'center',fontSize:16}}> Lütfen telefonunuza gelen şifreyi <b>{seconds}</b> saniye içinde girin; </p>
     
      <Form
                   onFinish={handleSubmit}
                    >
               
                <Row style={{marginBottom: -25,marginLeft:32}}>
               
                <Col span={15}>
                <Form.Item
                name="Sms"
                >
                <Input 
                 onKeyPress={(e) => { (e.key === 'e' || e.key === "E") && e.preventDefault(); }}
                onChange={() => { setErrorText("")}} type='number'/>
                </Form.Item>  
                </Col>
                <Col span={6}>
                <Form.Item  >
                <Button type="primary" htmlType="submit" onClick={() => setLoadingBtn(true)} loading={loadingBtn}>
                    Onayla
                </Button>
                </Form.Item>
                </Col>
                <Col span={3}></Col>
                </Row>
              </Form>
              <p style={{color:'darkred',textAlign:'center',fontWeight:600}}>{errorText}</p>
      </Modal>
      </div>
    </div>
       :
       <div>
                   <Result
                       status="404"
                       title="404"
                       subTitle="Üzgünüm, böyle bir kullanıcı bulamadım."
                       extra={<Button type="primary" href='/signin'> Giriş Sayfasına Dön</Button>}
                   />
               </div>
  );
  
};

export default ResetPassword;
